export default {"src":"/_next/static/media/error.9f01fa8e.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};